import React from 'react';
import aboutheader from '../../assets/images/about-header.webp';
import Heading from '../Headers/Heading';
import Art from '../Misc/Art';
import illustration from '../../assets/images/art_1.png';

function GetInvolvedHeader() {
    return (
        <>
            <div className="page-header position-relative">
                <Heading 
                    heading={<h1>Get Involved</h1>}
                    headingClass="heading-very-large dark-1"
                    paragraph="Become a volunteer or contributor with DMA Foundation and help us bring hope, healing, and professional care to underserved communities. Your skills and compassion can make a real impact."
                    paragraphClass="dark-2"
                    WrapperComponent={(props) => {
                        return (
                            <div className="page-header-top">
                                <div className="container">
                                    {props.children}
                                </div>
                            </div>
                        )
                    }}
                />
                <div className="page-header-bottom">
                    <div className="single-image">
                        <img src={aboutheader} alt="about-header" />
                    </div>
                </div>
                <Art art={illustration} type="1" />
            </div>
        </>
    );
}

export default GetInvolvedHeader; 